export default __webpack_public_path__ + "static/media/helping-old-2.354f2929.svg";